/**
 * Lightweight analytics helpers (Google Analytics via gtag).
 * gtag is loaded in public/index.html when a measurement ID is configured.
 * All calls are safe no-ops when gtag is unavailable (e.g. local dev, ad blockers).
 */

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const initGA = () => {
  // gtag bootstrap lives in index.html; nothing to do here unless we later
  // want to defer-load it. Kept for parity with the deployment template.
  if (!hasGtag()) {
    return;
  }
};

export const trackEvent = (action, params = {}) => {
  if (!hasGtag()) return;
  window.gtag('event', action, params);
};

export const trackWaitlistSubmitted = (location = 'unknown') => {
  trackEvent('waitlist_submitted', { location });
};

export const trackWaitlistSucceeded = (location = 'unknown') => {
  trackEvent('waitlist_succeeded', { location });
};

export const trackCtaClicked = (label, location = 'unknown') => {
  trackEvent('cta_clicked', { label, location });
};

export const trackCompanyInterestSubmitted = (location = 'unknown') => {
  trackEvent('company_interest_submitted', { location });
};

export const trackCompanyInterestSucceeded = (location = 'unknown') => {
  trackEvent('company_interest_succeeded', { location });
};

// Fired when a buyer clicks a Buy CTA and we open Stripe Checkout.
export const trackCheckoutSessionStarted = (location = 'unknown') => {
  trackEvent('checkout_session_started', {
    event_category: 'engagement',
    event_label: location,
    value: 1,
    currency: 'USD',
  });
};

// Reserved for the post-purchase success page (backend wiring is a follow-up).
export const trackPurchaseComplete = (value = 25) => {
  trackEvent('purchase', {
    event_category: 'ecommerce',
    event_label: 'stripe_checkout',
    value,
    currency: 'USD',
  });
};
